import React from 'react'

import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Button from '@material-ui/core/Button'
import GitHubIcon from '@material-ui/icons/GitHub';
import { Link } from 'react-router-dom'

import Grid from '@material-ui/core/Grid';

import Page from '../components/Page';


function Homepage() {

  const currentUser = "plasmatech8"

  return (
    <Page title="GitShares">
      <br />
      <br />
      <Container maxWidth="md">
        <Paper>
          <Box paddingX={5} paddingBottom={5} paddingTop={4}>

            <Typography variant="h4">Welcome to GitShares!</Typography>


            <Box paddingTop={4}>
              {
                currentUser ? (
                  <Button variant="contained"
                          color="primary"
                          component={Link}
                          to="/plasmatech8">
                    Go to account page
                  </Button>
                ) : (
                    <Button startIcon={<GitHubIcon />}
                            variant="contained"
                            color="primary">
                      Log in with Github
                    </Button>
                  )
              }
              <Box paddingX={1} display="inline">
                <Button variant="contained"
                        color="primary"
                        component={Link}
                        to="/plasmatech8/example-repo">
                  Go to example repo
                </Button>
              </Box>
            </Box>


            <Box paddingTop={5}>
              <Grid container>
                <Container maxWidth="md">
                  <Box align="left">

                    {/* What is GitShares? */}
                    <Typography variant="h5" >
                      What is GitShares?
                    </Typography >
                    <Typography variant="p" >
                      <p>
                        Imagine hosting open source projects where
                        contributors are rewarded and motivated-by the ownership
                        of shares in their favourite project.
                      </p>
                      <p>
                        GitShares is a way to assign and measure a user's contribution to an
                        Open-Source Project using a shareholder model.
                      </p>
                      <p>
                        It is a GitHub Application
                        (extension) that can be installed onto your repository from the
                        <a href="https://github.com/apps/gitshares"> GitHub Marketplace</a>.
                      </p>
                      <p>
                        Each share represents approximately <b>one hour</b> of productive development
                        for a GitHub repository.
                      </p>
                      <p>
                        These shares can be either pre-allocated, or issued during development as a
                        reward for any contribution.
                    </p>
                    </Typography>
                    <br />

                    {/* Future of GitShares */}
                    <Typography variant="h5" >
                      Vision
                    </Typography >
                    <Typography variant="p" >

                      <p>
                        An <b>open and decentralised</b> way to host, deploy and monetize open-source project.
                      </p>
                      <p>
                        GitShares will be a platform to host all kinds of projects
                        in which revenue is distributed between developers - based on their level of
                        contribution.
                      </p>
                      <p>
                        The platform can potentially manage CI and deployments of projects such as:
                      <ul>
                          <li>Websites</li>
                          <li>Applications</li>
                          <li>Games</li>
                          <li>Software Libraries</li>
                        </ul>
                      </p>
                      <p>
                        The platform can potentially manage revenue streams via APIs/SDKs:
                        <ul>
                          <li>Donations</li>
                          <li>Sponsorships</li>
                          <li>In-App purchases</li>
                          <li>Subscriptions</li>
                          <li>Advertisement</li>
                        </ul>
                        ...and distribute profits between contributors
                      </p>


                    </Typography>
                    <br />

                    {/* How to get started*/}
                    <Typography variant="h5" >
                      How to get started
                    </Typography >
                    <Typography variant="p" >
                      <p>
                        Installation:
                        <ol>
                          <li>Go to the GitHub app <a href="https://github.com/apps/gitshares">installation page for GitShares</a></li>
                          <li>Select the repositories you wish to install the app on.</li>
                        </ol>
                      </p>
                    </Typography>

                  </Box>
                </Container>
              </Grid>
            </Box>
          </Box>
        </Paper>
      </Container>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </Page>
  )
}

export default Homepage
